<template>
  <div id="maincarlist">
    <div>
      <img class="img-fluid mainimage"
        src="/static/images/top/import_list.png"/>
    </div>
    <div>
      <mdb-container>
        <div class="maintitlestyle">
          <span class="maintitleborder">
            수입차 가격표
          </span>
        </div>
        <div>
          <ul class="carIconlist"
            @click="listImportClick"
            @mouseover="listImportMouseOver"
            @mouseout="listImportMouseOut">
            <li>
              <brandImportIcon :list-array="filterImageBrand(brands, 'i')" />
            </li>
          </ul>
        </div>
        <div class='carlist d-none d-sm-block'
          v-if="simportorderbyid === 1" key='1-carImportImageList'>
          <carImageList :list-array="filterImage(cars, simportid, 'i')"/>
        </div>
        <div class='carlist d-none d-sm-block'
          v-else-if="simportorderbyid === 12" key='13-carImportImageList'>
          <carImageList :list-array="filterImageCar(cars, dimportcarid, 'i')"/>
        </div>
        <div class='carlistmobile d-block d-sm-none'
          v-if="simportorderbyid === 1" key='2-carImportImageListM'>
          <carImageListMobile :list-array="filterImage(cars, simportid, 'i')"/>
        </div>
        <div class='carlistmobile d-block d-sm-none'
          v-else-if="simportorderbyid === 12" key='13-carImportImageListM'>
          <carImageList :list-array="filterImageCar(cars, dimportcarid, 'i')"/>
        </div>
      </mdb-container>
    </div>
  </div>
</template>

<script>
import brandImportIcon from '../components/BrandImportIcon.vue';
import carImageList from '../components/CarImageList.vue';
import { brand, car } from '../api';

export default {
  data() {
    return {
      simportid: 0,
      simportorderbyid: 1,
      selecimportimgsrc: '',
      brands: [],
      cars: [],
    };
  },
  components: {
    brandImportIcon,
    carImageList,
  },
  created() {
    this.fetchData();
  },
  methods: {
    listImportClick(el) {
      const imglist = document.querySelectorAll('.mainimportimage');
      const simgsrc = el.target.src;
      if (simgsrc === this.selecimportimgsrc) return;
      imglist.forEach((elem) => {
        elem.src = elem.src.replace('_over.png', '.png');
      });
      el.target.src = el.target.src.replace('.png', '_over.png');
      this.selecimportimgsrc = el.target.src;
      this.simportid = parseInt(el.target.id, 10);
      this.simportorderbyid = 2;
      this.simportorderbyid = 1;
    },
    /* eslint-disable */
    filterImageBrand(Value, nation) {
      return Value.filter((item) => {
        return item.nation === nation;
      });
    },
    filterImage(Value, brandid, nation) {
      return Value.filter((item) => {
        if (brandid === 0 && item.nation === nation) {
          return true;
        }
        if (item.brandId === brandid && item.nation === nation) {
          return true;
        }
        return false;
      });
    },
        filterCar(Value, brandid, cargroupid) {
      return Value.filter((item) => {
        if (item.brandId === brandid && item.carGroupId === cargroupid) {
          return true;
        }
        return false;
      });
    },
    filterCarGroup(Value, brandid) {
      return Value.filter((item) => {
        if (item.brandId === brandid) {
          return true;
        }
        return false;
      });
    },
    filterImageCar(Value, carid, nation) {
      return Value.filter((item) => {
        if (item.id === carid && item.nation === nation) {
          return true;
        }
        return false;
      });
    },
    /* eslint no-param-reassign: "error" */
    listImportMouseOver(el) {
      const simgsrc = el.target.src;
      if (!simgsrc) return;
      if (simgsrc === this.selecimportimgsrc) return;
      el.target.src = el.target.src.replace('.png', '_over.png');
    },
    listImportMouseOut(el) {
      const simgsrc = el.target.src;
      if (!simgsrc) return;
      if (simgsrc === this.selecimportimgsrc) return;
      el.target.src = el.target.src.replace('_over.png', '.png');
    },
    fetchData() {
      brand.fetch()
        .then((data) => {
          this.brands = data.data;
          console.log(this.brands);
        });
      car.fetch()
        .then((data) => {
          this.cars = data.data;
        });
    },
  },
};
</script>

<style scoped>
.maintitlestyle{
  text-align: left;
  margin-top: 15px;
  color:#000;
  font-size: 22px;
  font-weight: bold;
  border-bottom: 1px solid gray;
  max-width: 1080px;
}

.maintitleborder{
  border-bottom: 4px solid #ffba00 !important;
}

.carIconlist{
  list-style: none;
  padding-left: 0px;
  margin: 3px 0px 3px 0px;
}

.carlist{
  align-content: center;
  margin-left: auto;
  margin-right: auto;
}

.button{
  background: url('/static/images/icons/requestbutton.png') no-repeat center center;
  width: 145px;
  height: 30px;
}
</style>
